import {Component} from '@angular/core';
import {Subscription} from "rxjs";
import {FormsService, ListsService, ObjectsService} from "@app/_services";
import { PagesService } from '@app/_services/pages.service';
import { PublicationsService } from '@app/_services/publications.service';

@Component({
  selector: 'grid',
  templateUrl: 'grid.component.html',
  styleUrls: ['grid.component.scss']
})
export class GridComponent {

  public classActive = '';

  public bright: number = 150;
  public contrast: number = 100;

  public newsUrl:string = '/novosti';
  public newsList:any[];

  subscription?: Subscription;

  constructor( private listsService: ListsService, private pagesService: PagesService, private publicationsService: PublicationsService, private formsService: FormsService, private objectsService: ObjectsService) {}

  ngOnInit() {
    this.subscription = this.listsService.result('class').subscribe(val => {
      this.classActive = val;
    });
    this.fetchNews()
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  get isRootPage(){
    return this.pagesService.currentPage && this.pagesService.currentPage.parents && this.pagesService.currentPage.parents.data.length == 0
  }

  get isHomePage(){
    return this.pagesService.currentPage?.link === '/'
  }

  fetchNews(){
    let include = [
    ];
    this.pagesService.find(this.newsUrl, {include: include.join(',')}).subscribe(res => {
      this.publicationsService.list({
        page:1,
        filters:{page:res.data.id},
        include:'posters'
      }).subscribe(
        result=>this.newsList = result.data
      )
    })
  }

  header(news){
    return news.name
  }

  link(news){
    return news.link
  }
  poster(news){
    return news.posters.data[0].links.thumb
  }

  get slide() {
    for (let slide of this.pagesService.currentPage.data.slides?.data) {
      return slide
    }
  }

  jumbotronEditor(){
    let attach = {model_type: 'page', model_id: this.pagesService.currentPage.id, group: 'slides', ord: 0};
    this.formsService.createObject('cards-section-slides', {extraProps: {attach: attach}})
  }

  edit() {
    this.formsService.editObject(this.slide.id);
  }

  move(ord) {
    this.objectsService.move(this.slide.id, {modelType: 'page', modelId: this.pagesService.currentPage.id, ord: ord}).subscribe(res => {
      this.listsService.refresh();
    });
  }

  destroy() {
    this.objectsService.destroy(this.slide.id).subscribe(res => {
      this.listsService.refresh();
    });
  }

}
